module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABU0lEQVQ4T62UvytFYRzGP09JJjEoikFSVjFJKbe7WIiBsvsD1E0xKIMkZfYPiAx+TJIMFptdoUxSBjZKHn3rvTque++h7ju9nfd7Pt/n+b7POaJBSw3ikAuyHTX9wIOk91qNa4JstwOLwDSwLOm4nvqqINsjwAHQCRQlXZQhtieAU0mfWfAvkO0+4BpoBXYlzWcgJWATWJe0kgfaA2ZT0aSkk9jbHgPOgSYg1MxIOirDfiiy3Qy8Ai2pYEDSje2upDKsllfUDUu6jQffINtxM2FjNVO8BITCUBAqtzJnyzHHaqDu1LUjU/wIDEp6st0L3KeziEGbpLda1gpxI2kOH0BB0mWaURE4Sy/uS5rLG3bY2QBKkr6t2N4BFtIMhyTd1QWl7uMV2RkFIkvP6bauKsP5l09kClgDDoFtSS/VEl4XlOLQU2nj36D//Blyrf0V1jDQF3gKcxMsX21yAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/jizhong_tab.png
// module id = VFni
// module chunks = 1